import { useTranslation } from 'react-i18next';
import { TenantStatus, UserStatus } from '@optiflow/types';
import { Badge } from './Badge';

/** Every status the shell renders today. Extend as modules land. */
export type Status = TenantStatus | UserStatus | 'ACTIVE' | 'INACTIVE';

type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'brand';

/**
 * Maps a domain status to a colour and a translation key in one place.
 *
 * Keeping the mapping here means "suspended is red" is decided once, rather than each table
 * inventing its own colour for the same word.
 */
const STATUS_TONES: Record<string, Tone> = {
  ACTIVE: 'success',
  TRIAL: 'brand',
  INVITED: 'brand',
  INACTIVE: 'neutral',
  SUSPENDED: 'warning',
  DISABLED: 'neutral',
  CANCELLED: 'danger',
};

export function StatusBadge({ status }: { status: Status | string }) {
  const { t } = useTranslation();
  const key = String(status).toUpperCase();

  return (
    <Badge tone={STATUS_TONES[key] ?? 'neutral'}>
      {t(`status.${key.toLowerCase()}`, { defaultValue: key })}
    </Badge>
  );
}

export function BooleanStatusBadge({ isActive }: { isActive: boolean }) {
  return <StatusBadge status={isActive ? UserStatus.ACTIVE : 'INACTIVE'} />;
}

export { TenantStatus, UserStatus };
